export const MAX_COUPON_CATALOG_TITLE_LENGTH = 100;
export const MAX_COUPON_CODE_LENGTH = 100;

export enum CouponCatalogType {
  ContentView = 'ContentView',
  AppInstall = 'AppInstall',
  ReplyWrite = 'ReplyWrite',

  AppInstallViewReply = 'AppInstallViewReply',
  ViewAndReply = 'ViewAndReply',

  Admin = 'Admin',
}

export enum CouponUsePolicy {
  Now = 'Now',
  Later = 'Later',
}

export enum CouponRewardType {
  RidiPointCoupon = 'RidiPointCoupon',
}
